function selectBranch(br, e) {
    jQuery("input[name='jdscf[Branch][hidden]']").empty().val(br);
    jQuery('.branchSwitch').empty().append(' - ' + br);
    jQuery(e).blur();
}

// Now we have two menus in one, close the other if the other is opened, so only one is open at a time
jQuery('button[data-target="#contactNavigationMob"]').click(function () {
    if (jQuery('#mainNavigation').hasClass('show')) {
        jQuery('#mainNavigation').removeClass('show');
    }
});

jQuery('button[data-target="#mainNavigation"]').click(function () {
    if (jQuery('#contactNavigationMob').hasClass('show')) {
        jQuery('#contactNavigationMob').removeClass('show');
    }
});

function closeStatusBar() {
    jQuery('.statusBar').css('display', 'none');
}



// When the user scrolls the page, execute myFunction
window.onscroll = function () {
    myFunction()

};

// Get the header
var header = document.getElementById("middleBar");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
    var width = jQuery(window).width();

    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
        jQuery('#searchForm').addClass('helloWorld');
        jQuery('.click-search').removeClass('helloWorld');
        if (width < 992) {
            jQuery('.lowerStrip').addClass('stickyMenu');
        }
    } else {
        header.classList.remove("sticky");
        jQuery('#searchForm').removeClass('helloWorld');
        jQuery('.click-search').addClass('helloWorld');
        if (width < 992) {
            jQuery('.lowerStrip').removeClass('stickyMenu');
        }
    }
}

// Show and hide the filters on click after search results shown

function toggleFilters() {
    jQuery('.filterBar').toggleClass('showFilter');
}

function goToPage(link, countryname, hotelname, resortname, nicedate, nights, rating, cheapestprice) {

    // dataLayer.push({
    //     'event': 'searched_deal',
    //     'country': countryname,
    //     'resort_name': resortname,
    //     'nights': nights,
    //     'rating': rating,
    //     'cheapest_price': cheapestprice,
    //     'departure_date': nicedate,
    //     'hotel_name': hotelname
    // });


    window.location = link;
}


function sortOffers(current, id) {

    var sort = jQuery('#sort_select').val(); // get selected value
    var direction = jQuery('#direction_select').val(); // get selected value

    var url = current;

    // Check if there is an ID in the URL

    if (id > 0) {
        url = url + '?id=' + id + '&sortBy=' + sort + '&direction=' + direction;
    } else {
        url = url + '?sortBy=' + sort + '&direction=' + direction;
    }

    window.location = url; // redirect

}

function selectFlight(id, depair, depairname, destairname) {

    selectedFlight = id;

    jQuery('.flightWrap').removeClass('selected');
    jQuery("#flightRow" + id).addClass('selected');

    jQuery('#chosenFlight').val(id);
    jQuery('#depair').val(depair);
    localStorage.setItem('depair', depair);
    jQuery('.depair').text(depairname);
    jQuery('.destair').text(destairname);


    var currentPrice = flights[id];


    var room1 = jQuery('#room1').val();
    var room2 = jQuery('#room2').val();
    var room3 = jQuery('#room3').val();
    var selectedRoomBits = room1.split('-');
    var selectedRoomId = selectedRoomBits[0];
    var selectedBoardBasis = selectedRoomBits[1];



    jQuery.each(flights, function (index, item) {

        console.log('index ', index);
        console.log('item ', item);
        console.log('currentPrice ', currentPrice);

        var diff = currentPrice - parseFloat(item);

        console.log('diff is ' + diff);

        if (diff > 0) {
            var output = "- £" + diff.toFixed(2) + ' pp';
        } else {
            output = "+ £" + Math.abs(diff).toFixed(2) + ' pp';
        }

        jQuery("#flightRow" + index + " .difference").text(output);
    });

    jQuery('.flightPrices').removeClass('d-none');

    changeDetail(room1, room2, room3, selectedRoom);

}

function createBookableOffer() {

}

function loadOffer(link, root, title) {
    var stateObj = {
        foo: "bar",
    };
    history.pushState(stateObj, "page 2", root);

    jQuery(".nivo-slider-wrapper").addClass('hideMe');
    jQuery("#searchForm").hide();
    jQuery("#loading").show();
    jQuery("html, body").animate({ scrollTop: 0 }, "fast");

    window.location.replace(link);

    // dataLayer.push({
    //     'event': 'deal_viewed',
    //     'deal_title': title
    // });
}

function dateClose() {
    jQuery('#datePickWrap').hide('slow');
    jQuery('body').removeClass('fix');
}

